




























import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import * as PIXI from 'pixi.js'
import anime from 'animejs'
// import { gsap, TweenMax, CSSPlugin, TweenLite } from 'gsap/all'
// import MotionPathPlugin from 'gsap/MotionPathPlugin'
// gsap.registerPlugin(MotionPathPlugin)

@Component
export default class Test extends Vue {
  mounted() {
    let el = document.getElementById('path')
    let offset = anime.setDashoffset(el)
    console.log('ddd', offset)

    anime({
      targets: el,
      strokeDashoffset: [offset, 50],
      duration: 2000,
      delay: anime.random(0, 2000),
      direction: 'normal',
      easing: 'easeInOutSine',
      autoplay: true
    })
  }
}
